<template>
  <div class="consult-expert-list-logout-btn" @click="logout" v-if="isShow">
    退出登录
  </div>
</template>

<script>
import { mobileLogout } from 'app/web/api/index.js'
import { addQueryToUrl } from 'app/frontend-lib/tools/utils.js'
export default {
  computed: {
    isShow() {
      return this.$runningEnv.env !== '' && this.isWebviewMp
    }
  },
  methods: {
    logout() {
      mobileLogout().then(res => {
        console.log(res)
        this.$store.dispatch('getUserInfo', true)
        if (this.$uniApp) {
          this.$uniApp.postMessage({
            type: 'setToken',
            data: {
              token: ''
            }
          })
          // this.$uniApp.postMessage({
          //   type: 'refresh'
          // })

          window.location.replace(
            addQueryToUrl(decodeURIComponent(window.location.href), {
              mpNativeRemoveToken: 1,
              token: ''
            })
          )
        }
        // window.location.reload()
      })
    }
  }
}
</script>

<style lang="scss">
.consult-expert-list-logout-btn {
  position: fixed;
  right: 0;
  top: 180px;
  margin-bottom: constant(safe-area-inset-bottom);
  background: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  border-radius: 40px 0 0 40px;
  width: 180px;
  height: 68px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 28px;
  color: #999;
  z-index: 2;
}
</style>
